<template>
    <content-page page-name="TERMSCONDITION"></content-page>
</template>

<script>
import ContentPage from "../components/ContentPage";

export default {
    name: "terms-of-use",

    components: { ContentPage }
};
</script>
